import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Stack, TableBody } from '@mui/material';

import { CustomTable, Text } from '../../shared/uiComponents';
import { CustomTableRow, RowTableCell } from '../../shared/uiComponents/Table/tableHelpers';
import { Wrapper } from '../../components/StyledComponents';
import { STROKE } from '../../shared/Helpers/colors';
import { errorNormalizer } from '../../shared/Helpers/functions';

import { AdpRateMapping, AdpRateMappingProperties } from '../../redux/API/ClientAPIHelpers/adpRateMapping';

const AdpRateIds = () => {
	const { userId } = useParams();
	const [mappings, setMappings] = useState<AdpRateMappingProperties[]>([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (!userId) return;
		setLoading(true);
		Promise.all(
			[AdpRateMapping.getAll(userId), AdpRateMapping.getServiceMappings(userId)].map((request) =>
				request.then((response) => {
					if (response?.error) throw response.error;

					return response || [];
				}).catch((error) => {
					errorNormalizer(error);

					return [];
				}),
			),
		)
			.then(([clients, services]) => setMappings([...clients, ...services]))
			.catch(errorNormalizer)
			.finally(() => setLoading(false));
	}, [userId]);

	if (loading || !mappings.length) return null;

	return (
		<Stack
			component={Wrapper}
			spacing={2}
			className="marginBottom16"
			width={420}
			maxWidth={{ xs: '100vw', sm: '100%' }}
			sx={{ border: `1px solid ${STROKE.PRIMARY}`, boxSizing: 'border-box' }}
		>
			<Text title="ADP Rate IDs" type="h6" fontWeight="semiBold" />
			{[
				{ title: 'Client', items: mappings.filter((mapping) => !mapping.serviceCodeId) },
				{ title: 'Service code', items: mappings.filter((mapping) => Boolean(mapping.serviceCodeId)) },
			].map(({ title, items }) => (
				<CustomTable
					key={title}
					headers={[
						{ id: 'name', name: title },
						{ id: 'rateId', name: 'ADP Rate ID', width: '140px' },
					]}
					data={{ query: items }}
					loading={false}
					fixedLayout
					hasPagination={false}
					hasMobile={false}
					TableBody={() => (
						<TableBody>
							{items.map((mapping) => (
								<CustomTableRow key={mapping.id}>
									<RowTableCell sx={{ overflowWrap: 'anywhere' }}>
										{mapping.serviceCodeName || mapping.clientFullName || mapping.clientId}
									</RowTableCell>
									<RowTableCell sx={{ overflowWrap: 'anywhere' }}>{mapping.rateId}</RowTableCell>
								</CustomTableRow>
							))}
						</TableBody>
					)}
				/>
			))}
		</Stack>
	);
};

export default AdpRateIds;
